module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3@2-30256b03b91b22a8bf9d10ab0616c748.webp";